var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import WorkMenuItem from "~/components/workspace/work-menu-item.vue";
import { State, namespace } from "vuex-class";
var workspaceModule = namespace("workspace");
var WorkMenu = /** @class */ (function (_super) {
    __extends(WorkMenu, _super);
    function WorkMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menuList = [];
        return _this;
    }
    WorkMenu.prototype.mounted = function () {
        var rescource = this.menuResource.filter(function (x) { return ["DIRECTORY", "MENU"].includes(x.type) && x.url; });
        var menus = rescource
            .filter(function (x) { return x.type === "DIRECTORY"; })
            .map(function (item) {
            var children = rescource
                .filter(function (x) { return x.parent === item.id && x.type === "MENU" && x.url; })
                .sort(function (x, y) { return x.resoSort - y.resoSort; });
            if (children && children.length) {
                return __assign(__assign({}, item), { children: children });
            }
            else {
                return item;
            }
        })
            .sort(function (x, y) { return x.resoSort - y.resoSort; });
        this.menuList = menus;
    };
    /**
     * 选择菜单项
     * 生成缓存项
     */
    WorkMenu.prototype.selectMenuItem = function (path, pathArray) {
        var _this = this;
        // 防止重复点击
        if (this.$route.path === path) {
            return;
        }
        // 路径长度验证
        if (pathArray.length !== 2) {
            return;
        }
        this.$nextTick(function () {
            _this.$router.push(path);
        });
    };
    __decorate([
        State
    ], WorkMenu.prototype, "menuResource", void 0);
    __decorate([
        State
    ], WorkMenu.prototype, "menuCollapse", void 0);
    WorkMenu = __decorate([
        Component({
            components: {
                WorkMenuItem: WorkMenuItem
            }
        })
    ], WorkMenu);
    return WorkMenu;
}(Vue));
export default WorkMenu;
